<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="抽出条件" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageMansionPrice ref="price" :menuSetting="menuSetting" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <v-form ref="floorThreshold">
        <CampaignModalPageMansionCondition
          :threshold="menuSetting.floorTarget.floorThreshold"
          :thresholdCondition="menuSetting.floorTarget.floorConditions"
          :isValid="menuSetting.isValidFloorTarget"
          @onChangeThreshold="updateFloorThreshold"
          @onChangeThresholdCondition="
            menuSetting.floorTarget.floorConditions = $event
          "
          @onChangeIsValid="menuSetting.isValidFloorTarget = $event"
          :title="'階数'"
          :suffixText="'階建て'"
        />
      </v-form>
    </v-flex>
    <v-flex xs12 offset-xs1>
      <v-form ref="ageBuiltThreshold">
        <CampaignModalPageMansionCondition
          :threshold="menuSetting.ageBuilt.ageBuiltThreshold"
          :thresholdCondition="menuSetting.ageBuilt.ageBuiltConditions"
          :isValid="menuSetting.isValidAgeBuilt"
          @onChangeThreshold="updateAgeBuiltThreshold"
          @onChangeThresholdCondition="
            menuSetting.ageBuilt.ageBuiltConditions = $event
          "
          @onChangeIsValid="menuSetting.isValidAgeBuilt = $event"
          :title="'築年数'"
          :suffixText="'年'"
        />
      </v-form>
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageMansionFloorPlan
        ref="floorPlan"
        :menuSetting="menuSetting"
      />
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="対象地域" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <AppAreaSelectorWithSplitGroupCheckbox :form="form" />
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import CampaignModalPageMansionFloorPlan from './CampaignModalPageMansionFloorPlan'
import CampaignModalPageMansionPrice from './CampaignModalPageMansionPrice'
import CampaignModalPageMansionCondition from './CampaignModalPageMansionCondition'

export default {
  name: 'CampaignModalPageMansion',
  components: {
    CampaignModalPageMansionFloorPlan,
    CampaignModalPageMansionPrice,
    CampaignModalPageMansionCondition,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    errorMessage() {
      const errorMessages = []
      if (!this.$refs.price.validate()) {
        errorMessages.push('抽出条件の価格を正しく設定してください')
      }
      if (!this.$refs.floorThreshold.validate()) {
        errorMessages.push('抽出条件の階数を正しく設定してください')
      }
      if (!this.$refs.ageBuiltThreshold.validate()) {
        errorMessages.push('抽出条件の築年数を正しく設定してください')
      }
      if (!this.$refs.floorPlan.validate()) {
        errorMessages.push('抽出条件の間取りを一つ以上設定してください')
      }
      if (this.form.campaign.menuSetting.hasNoConditions) {
        errorMessages.push('抽出条件を指定してください')
      }
      if (
        this.menuSetting.area.isEmpty(
          this.menuSetting.administrativeDistrictType,
        )
      ) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
  },
  methods: {
    updateFloorThreshold(value) {
      if (value === '') {
        value = undefined
      }
      this.menuSetting.floorTarget.floorThreshold = value
    },
    updateAgeBuiltThreshold(value) {
      if (value === '') {
        value = undefined
      }
      this.menuSetting.ageBuilt.ageBuiltThreshold = value
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
